import { ApplicationTypeEnum } from '@legacy/shared-types/enums/application-type.enum';
import { ProductCategoryEnum } from '@legacy/shared-types/enums/product-category.enum';
import { ProductRangeEnum } from '@legacy/shared-types/enums/product-range-type.enum';
import { ProductTypeEnum } from '@legacy/shared-types/enums/product-type.enum';
import { PermissionType } from '@enums/permissionType.enum';
import { IProductDataTransformed } from '@queries/products/useProductsList/types';
export type ProductKey = keyof IProductDataTransformed;

export type TableColumns =
  | 'description'
  | 'productCategory'
  | 'productRange'
  | 'productType'
  | 'monthsInitial'
  | 'maximumFTV'
  | 'initialRate'
  | 'productFees'
  | 'productFeesPercentage'
  | 'equityShare'
  | 'isActive';

export const tableColumnsNames: TableColumns[] = [
  'description',
  'productCategory',
  'productRange',
  'productType',
  'monthsInitial',
  'maximumFTV',
  'initialRate',
  'productFees',
  'productFeesPercentage',
  'equityShare',
];

export type ProductValue = string | number | ApplicationTypeEnum | ProductTypeEnum;

export const ALL_FILTER_OPTION = 'All';

export const productRangeFilterOptions: ProductRangeEnum[] = [
  ProductRangeEnum.Iman,
  ProductRangeEnum.IncomeMax,
  ProductRangeEnum.BrokerExclusive,
];

export const productTypeFilterOptions: ProductTypeEnum[] = [
  ProductTypeEnum.DISCOUNT,
  ProductTypeEnum.FIXED,
  ProductTypeEnum.TRACKER,
];

export const productCategoryFilterOptions: string[] = [
  ProductCategoryEnum.OWNER_OCCUPIED,
  ProductCategoryEnum.BUY_TO_LET,
];

export interface IProductFilters {
  productCategory: ProductCategoryEnum | 'All';
  productRange: ProductRangeEnum | 'All';
  ftv: number | string | 'All';
  isActiveProductsOnly: boolean;
  productType: ProductTypeEnum | 'All';
}
export type AllFiltersTypes = ApplicationTypeEnum | ProductTypeEnum | number | string | boolean | 'All';

export type FiltersKeys = keyof IProductFilters;

export const productsEditingAccessUsers: PermissionType[] = [
  PermissionType.ADMIN,
  PermissionType.BROKER,
  PermissionType.UNDERWRITER,
  PermissionType.FINANCE,
];

export const productsCloningAccessUsers: PermissionType[] = [
  PermissionType.ADMIN,
  PermissionType.UNDERWRITER,
  PermissionType.FINANCE,
];
